import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { getFont } from "app/regions/blocks/shared/fonts"
import { TwoColumnsLargeCTA as TwoColumnsLargeCTAEditor } from "./two-columns-large-cta"
import { TwoColumnsLargeCTASettings } from "./two-columns-large-cta-settings"
import TwoColumnsLargeCTAPreview from "./two-columns-large-cta-preview.png"

export const TwoColumnsLargeCTA = {
  name: "TwoColumnsLargeCTA",
  label: "large call to action with background",
  EditorComponent: TwoColumnsLargeCTAEditor,
  SettingsComponent: TwoColumnsLargeCTASettings,
  image: TwoColumnsLargeCTAPreview,
  defaultProperties: {
    backgroundColorLeft: "#3d3d3d",
    backgroundColorRight: "#F4F4F4",
    headingColorLeft: "#ffffff",
    textColorLeft: "#ffffff",
    headingColorRight: "#3B3D40",
    textColorRight: "#5D6268",
    horizontalPadding: 36,
    verticalPadding: 36,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#e3e3e3",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    headingFontFamily: getFont("Verdana"),
    headingFontWeight: 700,
    textFontFamily: getFont("Verdana"),
    textFontWeight: 400,
    leftImage: "",
    rightImage: ""
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "Title", { alignment: "center" }),
      paragraph("Lorem ipsum dolor sit amet, consectetur adipiscing elit.", {
        alignment: "center"
      }),
      button("Learn more", {
        backgroundColor: "#ffffff",
        color: "#000000",
        size: "medium"
      })
    ]),
    customTextBlock([
      heading("two", "Title", { alignment: "center" }),
      paragraph("Lorem ipsum dolor sit amet, consectetur adipiscing elit.", {
        alignment: "center"
      }),
      button("Learn more", {
        backgroundColor: "#000000",
        color: "#ffffff",
        size: "medium"
      })
    ])
  ]
}
